export enum PostMessageEventNames {
  PaymentStatus = 'paymentStatus',
  PaymentFailed = 'paymentFailed',
  PaymentFinished = 'paymentFinished'
}

export enum PostMessageStatuses {
  success = 'success',
  NewCardSuccess = 'NewCardSuccess',
  NewCardFailed = 'NewCardFailed'
}
